function updateBannerValue(response) {
  var customer = response.data.customers[0];
  var loyaltyTier = customer.loyalty_tier_membership.loyalty_tier;
  var approvedPoints = customer.points_approved
  var mainElementClass = $('.gettingPoint');
  var number = loyaltyTier.number
  number = 1
  switch (number) {
    case 1: // Vault Member
      var points = parseFloat(approvedPoints);
      if (!isNaN(points)) {
        var dollars = (points * 0.01).toFixed(2);
        mainElementClass.text('$' + dollars)
        $('.gettingPoint,.loyalty-description').removeClass('hide')
      }
      break;
    case 2: // Vault Insider
      var points = parseFloat(approvedPoints);
      if (!isNaN(points)) {
        var dollars = (points * 0.013).toFixed(2);
        mainElementClass.text('$' + dollars)
        $('.gettingPoint,.loyalty-description').removeClass('hide')
      }
      break;
    case 3: // Vault VIP
      var points = parseFloat(approvedPoints);
      if (!isNaN(points)) {
        var dollars = (points * 0.015).toFixed(2);
        mainElementClass.text('$' + dollars)
        $('.gettingPoint,.loyalty-description').removeClass('hide')
      }
      break;
  }
}

function updateTierBenefit(response) {
  var number = response.data.customers[0].loyalty_tier_membership.loyalty_tier.number
  $(".loyalty-table-" + number).addClass("td-border-lr");
  $(".loyalty-table-" + number).last().removeClass("td-border-lr").addClass("td-border-lrb");
  $(".loyalty-header-" + number).addClass("thead-border");
  $(".lion-rule-item--completed-forever").find(".lion-rule-item__points").addClass("hide")
  $(".lion-rule-item.lion-rule-item--signup.lion-rule-item--authenticated").addClass("hide");
  $(".more-ways-to-earn-points").removeClass("hide");
}

var intervalId;
function refreshUI() {
  if ($(".lion-action-button.lion-action-button--tile").length === 0 && $(".lion-reward-item--customer").length === 0) {
    setTimeout(refreshUI, 200);
  } else {
    $(".lion-rule-item--authenticated, .lion-reward-item--customer").off('click').on('click', function () {
      var originalCount = $(".lion-history-table").find("tr.lion-history-table__row").first().find(".lion-history-table__row-cell.lion-history-table__row-cell--empty-state").length !== 0 ? 0 : $(".lion-history-table").find("tr.lion-history-table__row").length;
      // Clear any previous interval
      if (intervalId) {
        clearInterval(intervalId);
      }

      intervalId = setInterval(function () {
        var currentCount = $(".lion-history-table").find("tr.lion-history-table__row").first().find(".lion-history-table__row-cell.lion-history-table__row-cell--empty-state").length !== 0 ? 0 : $(".lion-history-table").find("tr.lion-history-table__row").length;

        if (originalCount !== currentCount) {
          clearInterval(intervalId);
          intervalId = null; // Clear the intervalId reference
          refreshUIValues();
          loyaltyVoucherRefreshUI()
        }
      }, 1000);

      // Set timeout to clear the interval if it hasn't already been cleared
      var autoStopTimeout = setTimeout(function () {
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null; // Clear the intervalId reference
        }
      }, 60000);
    });
  }
}

function refreshUIValues() {
  var settings = {
    url: `${portalApiUrl}/loyalty-lion-email-search`,
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      email: loggedInCustomerEmail,
    }),
  };
  $.ajax(settings).done(function (response) {
    updatePointsValue(response);
    updateProgressBar(response);
    updateBannerValue(response);
    updateTierBenefit(response);
  });
}

function hideLearnMore() {
  if ($(".lion-action-button.lion-action-button--tile").length === 0) {
    setTimeout(hideLearnMore, 200);
  } else {
    $(".lion-action-button.lion-action-button--tile").each(function () {
      if ($(this).text().trim() === "Learn more") {
        $(this).css("color", "#000");
      }
      if ($(this).text().trim() === "Refer a friend") {
        $(this).css("color", "#000");
      }
    });
  }
}

function loyaltyVoucherRefreshUI() {
  var nodes = document.getElementsByClassName('lion-rewards-list');
  if (nodes.length > 0) {
    for (var i = 0; i < nodes.length; i++) {
      $('.lion-reward-item').each(function () {
        var titleText = $(this).find('.lion-reward-item__title').text();
        var rewardButton = $(this).find('.lion-action-button').text().toLowerCase().trim();
        if (rewardButton !== 'more points needed') {
          titleText = titleText.replace(/credit|collection/gi, '').trim();
          $(this).find('.lion-action-button.lion-action-button--tile').each(function () {
            $(this).find('.lion-reward-item__redeem-button-text').text(`Redeem ${titleText}`);
          });
        }
        if (rewardButton === "more points needed") {
          $(this).addClass('lion-reward-item-disabled');
        }
      });
    }
  }
}

$(document).ready(function () {
  hideLearnMore();
  refreshUI();
});
